<template>
  <div>
    <div class="d-flex justify-content-between align-self-center my-4">
      <AGCLabel>
        <span class="title">銀行資料</span>
        <template v-slot:subLabel v-if="role === 'merchant'">
          <span>
            (只限更改一次。如需更新銀行資料，請電郵至
            <a href="mailto:eCoupon@ulifestyle.com.hk">eCoupon@ulifestyle.com.hk</a>)</span
          >
        </template>
      </AGCLabel>
    </div>
    <AGCEditGroupInput v-model="inputVal.bankName"
                       class="custom-dropdown"
                       :fieldName="'bankName'"
                       inputType='dropdown'
                       label="銀行名稱"
                       name="銀行名稱"
                       rules="required"
                       disabled
                       required
                       @is-save="bankInfo.bankName = true"
                       :options="bankOptions"
                       :enableEdit="!bankInfo.bankName || role === 'admin'"
    >
    </AGCEditGroupInput>
    <AGCEditGroupInput v-model="inputVal.bankAddress"
                       :fieldName="'bankAddress'"
                       label="銀行地址"
                       name="銀行地址"
                       rules="required|max:200"
                       type="text"
                       disabled
                       required
                       @is-save="bankInfo.bankAddress = true"
                       :enableEdit="!bankInfo.bankAddress || role === 'admin'"
    >
    </AGCEditGroupInput>
    <AGCEditGroupInput v-model="inputVal.bankNumber"
                       :fieldName="'bankNumber'"
                       label="戶口號碼"
                       name="戶口號碼"
                       rules="required|numeric"
                       type="text"
                       disabled
                       required
                       @is-save="bankInfo.bankNumber = true"
                       :enableEdit="!bankInfo.bankNumber || role === 'admin'"
    >
    </AGCEditGroupInput>
    <AGCEditGroupInput v-model="inputVal.bankUsername"
                       :fieldName="'bankUsername'"
                       label="戶口名稱"
                       name="戶口名稱"
                       rules="required|max:50"
                       type="text"
                       disabled
                       required
                       @is-save="bankInfo.bankUsername = true"
                       :enableEdit="!bankInfo.bankUsername || role === 'admin'"
    >
    </AGCEditGroupInput>
    <AGCEditGroupInput v-model="inputVal.bankRemark"
                       :fieldName="'bankRemark'"
                       label="備注"
                       name="備注"
                       type="text"
                       disabled
                       :inputType="'textarea'"
                       @is-save="bankInfo.bankRemark = true"
                       :enableEdit="!bankInfo.bankRemark || role === 'admin'"
    >
    </AGCEditGroupInput>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import AGCEditGroupInput from '../form/AGCEditGroupInput.vue';
import AGCLabel from '../form/AGCLabel.vue';

import formMixin from '../../mixins/form';
import vModelMixin from '../../mixins/v-model';

export default {
  mixins: [formMixin, vModelMixin],
  components: {
    AGCEditGroupInput,
    AGCLabel,
  },
  data: () => ({
    bankOptions: [
      { value: 'BOC', text: '中國銀行(香港)有限公司 BOC' },
      { value: 'HSBC', text: '香港上海滙豐銀行有限公司 HSBC' },
    ],
    bankInfo: {},
  }),
  computed: {
    ...mapGetters(['role']),
  },
  mounted() {
    this.bankInfo = { ...this.inputVal };
  },
};
</script>

<style lang="scss" scoped>
  ::v-deep {
    .custom-dropdown {
      .custom-select {
        width: auto;
        font-size: 0.98em;
      }
    }
  }
</style>
